export default __webpack_public_path__ + "static/media/access_control_locations_icons_residential.bee2d557.svg";